<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12">
        <v-text-field v-model="searchArquivos" clearable color="#6e6e6e" class="mt-0 pt-0"
          placeholder="Buscar em anotações" v-on:keyup.enter="reloadAnotacoes()">
          <template v-slot:append-outer>
            <v-btn text><v-icon class>mdi-magnify</v-icon> Buscar</v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel v-for="(lei, index) in anotacoesPorLei" :key="index">
            <v-expansion-panel-header class="d-flex flex-column align-start ">

              {{ lei[0].id_lei.numero_lei }}
              <small class="mt-1">{{ lei[0].id_lei.nome_lei }}</small>
              <v-btn :to="`/painel/lei/${lei[0].id_lei.id_lei}/${sanitizeTitle(lei[0].id_lei.numero_lei)}`" text small
                class="pl-0">Abrir lei</v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="annotation" v-for="a in lei" :key="a.id"
              style="background-color: #f5f5f5; padding: 20px 0px; border: 1px solid #d7d7d7;">
              <p class="reg mx-0 "> {{ a.id_reg.conteudo }} </p>
              <p v-html="a.texto"></p>
              <p class="d-flex flex-column align-end ">
                <span>
                  <v-btn text
                    :to="`/painel/lei/${lei[0].id_lei.id_lei}/${sanitizeTitle(lei[0].id_lei.numero_lei)}?id=${a.id_reg.id_reg}`">
                    <v-icon>mdi-arrow-right-top</v-icon> Ir até o registro</v-btn>
                </span>
                <small class="pr-4">
                  <span v-if="a.status === `group`">
                    <v-icon>mdi-account-group</v-icon>
                    {{ a.id_grupo.nome_grupo }}
                  </span>
                  <span v-else>
                    <v-icon small>{{
                      a.status === `private`
                      ? `mdi-lock`
                      : `mdi-earth`
                    }}</v-icon>
                    {{ a.status | filterStatus }}
                  </span>
                  -
                  <v-icon small>mdi-clock-outline</v-icon>
                  {{ a.date_updated === null ? "Criado em" : "Atualizado em" }}
                  {{ a.date_updated === null ? a.date_created : a.date_updated | brdatetime }}
                </small>
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

a {
  color: #F15A24 !important;
  text-decoration: none;
}

.annotation {
  border: 1px solid rgb(200 200 200);
  margin: 8px 0px;
  border-radius: 10px;
}

.reg {
  border: 1px dashed black;
  border-radius: 10px;
  padding: 5px;
}
</style>
<script>
export default {
  name: "Anotacoes",
  data() {
    return {
      selected: 0,
      items: [],
      anotacoes: [],
      anotacoesArquivadas: [],
      id_anotacao: null,
      anotacoesPorLei: {},
      loadingArquivos: false,
      searchArquivos: null,
      order: "DESC",
      page: 1,
      perPage: 5,
      totalPalavras: 0,
      totalPalavrasFiltrado: 0,
      buscou: false,
    };
  },
  mounted() {
    this.reloadAnotacoes()
    this.reloadAnotacoesArquivadas()
  },
  methods: {
    reloadAnotacoes() {
      this.$http(`items/anotacoes?sort=-date_created&fields=*,id_reg.id_reg,id_reg.conteudo,id_lei.nome_lei,id_lei.numero_lei,id_lei.id_lei&filter[user_created][_eq]=${this.$store.state.user.id}&filter[id_lei][_nnull]=true&filter[status][_neq]=archived`).then(res => {

        res.data.data.forEach(el => {
          let lei = el.id_lei.id_lei.toString()
          if (this.anotacoesPorLei[lei] === undefined) { this.anotacoesPorLei[lei] = [] }

          this.anotacoesPorLei[lei].push(el)
          this.id_anotacao = el.id_reg
        })
        this.$forceUpdate()
      })
    },
    reloadAnotacoesArquivadas() {
      this.$http(`items/anotacoes?sort=-date_created&fields=*,id_lei.numero_lei,id_lei.id_lei&filter[user_created][_eq]=${this.$store.state.user.id}&filter[status][_eq]=archived`).then(res => {
        this.anotacoesArquivadas = res.data.data
      })
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  }
}
</script>
